import { render, staticRenderFns } from "./SidesheetDetalleHistorialAcuerdoComercial.vue?vue&type=template&id=7680a5b3"
import script from "./SidesheetDetalleHistorialAcuerdoComercial.vue?vue&type=script&lang=js"
export * from "./SidesheetDetalleHistorialAcuerdoComercial.vue?vue&type=script&lang=js"
import style0 from "./SidesheetDetalleHistorialAcuerdoComercial.vue?vue&type=style&index=0&id=7680a5b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VTab,VTabItem,VTabs,VTabsItems})
